import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';

import { ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gea-hrt-update-time',
  standalone: true,
  imports: [DatePipe],
  template: `<span [title]="date() | date: 'd/MM/yyyy - HH:mm zzzz'">
    {{ date() | date: GetFormat() }}
  </span> `,
})
export class UpdateTimeComponent {
  currentLanguage = 'en-US';
  readonly date = input.required<string | Date>();
  /**
   * Optional custom date format (Angular DatePipe format string).
   * Example: "dd/MM/yyyy hh:mm:ss"
   */
  readonly format = input<string>();

  GetFormat(): string {
    // If a custom format is provided, prefer it.
    const format = this.format();
    if (format && format.trim()) return format;

    switch (this.currentLanguage) {
      case 'de-DE':
        return 'dd.MM.';
      case 'en-US':
      default:
        return 'dd/MM';
    }
  }
}
